import { FeaturesType } from '@/actions/fetchFeatures';
import { createContext, ReactNode } from 'react';

type FeatureToggleProviderType = {
  children: ReactNode;
  featureFlags: FeaturesType;
};

const FeatureToggleContext = createContext({
  featureFlags: {} as FeaturesType,
});

const FeatureToggleProvider = (props: FeatureToggleProviderType) => {
  const { children, featureFlags } = props;
  return (
    <FeatureToggleContext.Provider value={{ featureFlags: featureFlags }}>
      {children}
    </FeatureToggleContext.Provider>
  );
};
FeatureToggleContext.displayName = 'Feature';
export { FeatureToggleContext, FeatureToggleProvider };
